import { render, staticRenderFns } from "./confirm-admin.vue?vue&type=template&id=17348cf5"
import script from "./confirm-admin.vue?vue&type=script&lang=js"
export * from "./confirm-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports